import { normalizeParentMe } from '@/helper/parentNormalize';

const outlet = { id: 2, name: 'Demo Outlet' };

const childA = {
	id: 10,
	member: {
		id: 342,
		name: 'BUDIARJO Aurelia Safira',
		on_list_attributes: {
			class: 'Kinder A',
			student_id: '24024',
			customer_type: 'Student',
			dietary_preferences: [],
			contact: null,
		},
	},
	outlet,
	balance: '301500.000',
	is_active: true,
};

const childB = {
	id: 6,
	member: {
		id: 353,
		name: 'BALA SUBRAMANIAM Kaira',
		on_list_attributes: {
			class: 'Kinder B',
			student_id: null,
			customer_type: 'Student',
			dietary_preferences: [],
			contact: null,
		},
	},
	outlet,
	balance: '2500.000',
	is_active: false,
};

const parentUser = {
	id: 337,
	name: 'mother',
	email: 'mother@exampleparent.com',
	username: 'mother@exampleparent.com_customer-dev',
	is_active: true,
};

/** Fixtures matching Postman / D1 contract shapes (0 / 1 / 2 children). */
export const mockParentMeFixtures = {
	parentZeroChildren: normalizeParentMe({
		account_type: 'parent',
		user: parentUser,
		customer: null,
		outlet,
		children: [],
	}),
	parentOneChild: normalizeParentMe({
		account_type: 'parent',
		user: parentUser,
		customer: null,
		outlet,
		children: [childA],
	}),
	parentTwoChildren: normalizeParentMe({
		account_type: 'parent',
		user: parentUser,
		customer: null,
		outlet,
		children: [childA, childB],
	}),
	legacyOneChild: normalizeParentMe({
		account_type: 'legacy',
		user: { ...parentUser, name: 'Legacy Student' },
		customer: childA,
		outlet,
		children: [childA],
	}),
};

export function mockParentDashboard(date, children = [childA]) {
	const day = date || new Date().toISOString().slice(0, 10);
	return {
		date: day,
		generated_at: new Date().toISOString(),
		summary: {
			ordered: 0,
			not_ordered: children.length,
			cancelled: 0,
			inactive: children.filter((c) => !c.is_active).length,
		},
		children: children.map((c) => ({
			...c,
			status: c.is_active ? 'not_ordered' : 'inactive',
			serving_times: [],
		})),
	};
}
